export function setTitle(infos: MraidInfos) {
  let title =
    '[' +
    String(infos.env) +
    '] ' +
    String(infos.formatName) +
    ' - ' +
    String(infos.campaignId);

  const viewability =
    typeof infos.isViewable === 'boolean'
      ? infos.isViewable
        ? 'viewable'
        : 'notViewable'
      : '';
  if (infos.state || viewability) {
    title += ' (';
    if (infos.state) {
      title += infos.state;
    }
    if (infos.state && viewability) {
      title += ' ';
    }
    if (viewability) {
      title += viewability;
    }
    title += ')';
  }
  document.title = title + ' #' + String(infos.hash);
}
